export default __webpack_public_path__ + "src/assets/unidai-mobile.b9dcee9907df27ddae0f02d45b6b45d4.svg";